export const INITIAL = 'Manual'

export enum EAccountType {
  PERSONAL = 'personal',
  BUSINESS = 'business',
}

export const CARD_ERROR_TYPE = {
  INVALID_CARD: 'invalid_card',
  ADDRESS_MISMATCH: 'address_mismatch',
  CVV_ERROR: 'cvv_error',
  NETWORK_ERROR: 'network_error',
  INVALID_CARD_NUMBER: 'invalid_card_number',
  DECLINED_CARD: 'declined_card',
  INSUFFICIENT_FUNDS: 'insufficient_funds',
  EXPIRED_CARD: 'expired_card',
  LIMIT_EXCEEDED: 'limit_exceeded',
  INVALID_ADDRESS: 'invalid_address',
  MISSING_ADDRESS_LINE1: 'missing_address_line1',
  INVALID_ZIPCODE: 'invalid_zipcode',
  ADDRESS_VERIFICATION_ERROR: 'address_verification_error',
  STOLEN_CARD: 'stolen_card',
  SECURITY_VIOLATION: 'security_violation',
  INVALID_TRANSACTION: 'invalid_transaction',
  TRANSACTION_NOT_PERMITTED: 'transaction_not_permitted',
  DUPLICATE_TRANSACTION: 'duplicate_transaction',
  FREQUENCY_LIMIT: 'frequency_limit',
  INVALID_CARD_DATE: 'invalid_card_date',
  INVALID_CARD_CVV: 'invalid_card_cvv',
  INVALID_CARD_FOR_PULLS: 'invalid_card_for_pulls',
}

export type CardErrorType = typeof CARD_ERROR_TYPE[keyof typeof CARD_ERROR_TYPE]

export const PAY_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export type PayStatus = typeof PAY_STATUS[keyof typeof PAY_STATUS]
